// Persiste el "contexto de navegación" del listado (filtros + orden) para que las
// vistas de detalle puedan ofrecer flechas anterior/siguiente recorriendo la lista
// tal y como se mostró en el listado.
//
// Se usa localStorage (no sessionStorage) a propósito: así el contexto está
// disponible también al abrir el detalle en una pestaña nueva (Ctrl+click /
// botón central), que NO hereda el sessionStorage de la pestaña original.

const keyFor = (entity) => `navCtx:${entity}`;

export const saveNavContext = (entity, ctx) => {
  try {
    localStorage.setItem(keyFor(entity), JSON.stringify(ctx || {}));
  } catch (_) {
    /* localStorage no disponible: degradar sin flechas */
  }
};

export const getNavContext = (entity) => {
  try {
    return JSON.parse(localStorage.getItem(keyFor(entity)) || "null");
  } catch (_) {
    return null;
  }
};
